module.exports = __webpack_public_path__ + "img/selected0-min.4835e2b8.png";